import { useTranslation } from "react-i18next";
import CONFIG from "./config";

export interface BannerConfig {
  id: string;
  title: string;
  description: string;
  secondaryText?: string;
  primaryAction: { label: string; onClick: () => void };
  secondaryAction?: { label: string; onClick: () => void };
  disabled?: boolean;
}

export const useBannerConfig = (): BannerConfig[] => {
  const { t } = useTranslation();

  return [
    {
      id: "catalogues",
      title: t("home.banner.catalogues.title"),
      description: t("home.banner.catalogues.description"),
      primaryAction: { 
        label: t("home.banner.catalogues.cta"), 
        onClick: () => window.open('/catalogues', "_blank") 
      },
      secondaryAction: {
        label: t("home.banner.catalogues.help"),
        onClick: () => window.open(`${CONFIG.CONTACT_INFO.INSTAGRAM}`, "_blank")
      }
    },
    {
      id: "website-services",
      title: t("home.banner.website.title"),
      description: t("home.banner.website.description"),
      primaryAction: { 
        label: t("home.banner.website.pricing"),
        onClick: () => window.open('/benefits', "_blank")
      },
    },
    {
      id: "mission",
      title: t("home.banner.mission.title"),
      description: t("home.banner.mission.description"),
      primaryAction: { 
        label: t("home.banner.mission.cta"), 
        onClick: () => window.open('https://calendly.com/eateliers', "_blank") 
      }
    },
    {
      id: "support",
      title: t("home.banner.support.title"),
      description: t("home.banner.support.description"),
      primaryAction: { 
        label: t("home.banner.support.cta"), 
        onClick: () => window.open(`mailto:${CONFIG.CONTACT_INFO.EMAIL}`, "_blank") 
      },
    //   secondaryAction: {
    //     label: t("home.banner.support.docs", "Documentation"),
    //     onClick: () => window.open('/docs', "_blank")
    //   }
    },
  ];
}; 